var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-filter"},[_c('filter-ui',{ref:"filterUi",attrs:{"disabled":_vm.loading,"value":_vm.prepared,"filters":_vm.filters,"pagination":_vm.pagination,"additional-resource":_vm.additionalResource,"label":_vm.label,"hasOtherFilter":_vm.hasOtherFilter,"changeFilters":_vm.changeFilters},on:{"input":_vm.handleInputFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }